import InputGroup from './inputGroup'
import Addon from './addon'

InputGroup.Addon = Addon

export default InputGroup